import { AttributeInfo, AnyHandler, AggregatorTotalsHandler } from 'src/app/types/@types/sl-v-types';
import { SLAggregator } from './slaggregator';
import { Column } from 'angular-slickgrid';

export class LastAggregator extends SLAggregator {
	protected _name = 'last';
	protected _label = 'Last';
	protected requiresNumber = false;
	constructor() {
		super();
	}
	init() {
		super.init();
	}
	Accumulate(item: any, column: Column<any>) {
		this._value[column.id] = item[column.id];
	}
	SetTotals(totals: any, completeHandler?: AggregatorTotalsHandler) {
		super.SetTotals(totals);
		this.EndAggregation(totals, completeHandler);
	}

}